import { UserHomeModule } from '../models/user.types'

export const USER_HOME_STATUSES: {
  value: string
  label: string
  modules: UserHomeModule[]
}[] = [
  {
    value: 'CONFIRMED',
    label: 'Confermato',
    modules: ['GOODS_RECEIVES'],
  },
  {
    value: 'PENDING',
    label: 'In attesa',
    modules: ['ORDERS'],
  },
  {
    value: 'PROCESSING',
    label: 'In lavorazione',
    modules: ['GOODS_RECEIVES'],
  },
  {
    value: 'PROCESSING',
    label: 'In prelievo',
    modules: ['PICKING_LISTS', 'ORDERS', 'REPLENISHMENTS'],
  },
  {
    value: 'PENDING',
    label: 'Da prelevare',
    modules: ['PICKING_LISTS', 'REPLENISHMENTS'],
  },
  {
    value: 'TOTAL',
    label: 'Totale',
    modules: ['PRODUCTS', 'LOCATIONS'],
  },
]
